module.exports = __webpack_public_path__ + "static/media/6-_DSC9276.b4ec4f94.jpg";